export const APP_ORIGIN = import.meta.env.DEV
  ? 'http://localhost:5173'
  : 'https://app.exis.pro';

import type { BillingFrequency } from './billing/billingFrequency';

export const PRO_TRIAL_RETURN = '/settings/billing?start=trial';
export const STARTER_CHECKOUT_RETURN =
  '/settings/billing?start=checkout&plan=starter';

function appSignupReturningTo(
  returnPath: string,
  frequency: BillingFrequency,
): string {
  const returnTo =
    frequency === 'year' ? `${returnPath}&cadence=year` : returnPath;
  return `${APP_ORIGIN}/login?return_to=${encodeURIComponent(returnTo)}`;
}

export function appSignupForProTrial(frequency: BillingFrequency): string {
  return appSignupReturningTo(PRO_TRIAL_RETURN, frequency);
}

export function appSignupForStarter(frequency: BillingFrequency): string {
  return appSignupReturningTo(STARTER_CHECKOUT_RETURN, frequency);
}
